import React from "react";
import { Link, Outlet } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import { Logo } from "../ui/Logo";
import { ThemeToggle } from "../ui/ThemeToggle";
export function AuthLayout() {
  return <div className="pat-hatch flex min-h-screen w-full flex-col bg-paper font-sans text-ink" data-id="element-482" data-mp="vjobu5cff17c">
      <header className="mx-auto flex w-full max-w-5xl items-center justify-between px-5 py-5 md:px-8" data-id="element-483" data-mp="10iiw7bq1kxtk">
        <Logo data-id="element-484" data-mp="mizzdf2ol8wk" />
        <div className="flex items-center gap-2.5" data-id="element-485" data-mp="mihs7nehda9v">
          <Link to="/" className="focus-ring hidden items-center gap-1.5 rounded-xl px-3 py-2 text-sm font-semibold text-ink-2 hover:text-ink sm:flex" data-id="element-486" data-mp="qlwc4p5jiasl">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-487" data-mp="hkg9j3kyvcyx" />
            Back to site
          </Link>
          <ThemeToggle data-id="element-488" data-mp="26zmpkmijubew" />
        </div>
      </header>
      <main className="flex flex-1 items-start justify-center px-5 pb-16 pt-4 md:items-center md:pt-0" data-id="element-489" data-mp="270xrshwcjb3w">
        <div className="w-full max-w-md" data-id="element-490" data-mp="2by7hzzrk7qss">
          <Outlet data-id="element-491" data-mp="2v6ej2omtiqos" />
        </div>
      </main>
    </div>;
}